import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { DocumentDetailsPage } from "components/common/DocumentDetailsPage";
import { findState } from "components/common/DocumentDetailsPage/utils";
import { initalizeStepsData } from "components/common/StepsContentGrid";
import StepsItemView from "components/common/StepsItemView";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, useHistory, useParams } from "react-router-dom";
import { getDocument, getDocumentsByType } from "services/users";

// const PageWrapper = styled.div`
//   width: 100%;
//   padding-top: 22px;
//   padding-left: 37px;
//   padding-right: 51px;
//   @media (max-width: 900px) {
//     padding: 30px 4px;
//   }
// `;

const config = [
    'Total',
    'Price',
    'Quantity',
    'Currency Type',
    'Type',
    'Approval Date',
    'Step'
];

type RouteParams = {
    id: string;
};

const WithdrawalDetails: React.FC<RouteComponentProps> = () => {
    const { t } = useTranslation();
    const { id } = useParams<RouteParams>();

    const history = useHistory();
    const { user, userCore } = useSelector(
        (state: any) => state.authReducer
    );

    const [data, setData] = useState<any>(null);
    const [withdrawalData, setWithdrawalData] = useState<any>(null);
    const [bankDetailsData, setBankDetailsData] = useState<any>(null);

    const processDocument = (doc: any) => {
        //console.log(doc);
        setWithdrawalData(doc);
        const data: any = initalizeStepsData(t("withdrawal_string"), ["", "USD ⇄ EUR", "EUR ⇄ NIS", "NIS"]);
        const coins: any = {};

        const setDocumentCoins = (active: boolean, savedCoins?: any[], date?: any) => {
            let i = 1;

            doc.meta.coins.forEach((coin: any) => {
                const savedCoin = savedCoins ? savedCoins.find((c: any) => c.coin == coin.coin) : undefined;
                //const sold=doc.meta?.coins?doc.meta?.coins.find((c:any)=>c.coin==coin.coin):null;
                let quantity = coin.usdtVolume;
                let price = coin.price;
                if (savedCoin) {
                    quantity = savedCoin.usdtVolume;
                    price = savedCoin.price;
                }

                // const setEditable = () => {
                //     row.setQuantity = (quantity: number) => coinsData[coin.coin].quantity = quantity;
                //     row.setPrice = (price: number) => { row.price = price ? 1 / price : 0; console.log("price", row.price); coinsData[coin.coin].price = row.price; };
                //     row.editable = { quantity: true };
                //     row.quantityMask = 'cryptoprice';
                //     row.priceModifier = -1;
                //     row.actions = {
                //         save: {
                //             title: "Save",
                //             action: (onError: IActionErrorHandler) => {
                //                 quantityValidateSchema.validate({ quantity: coinsData[coin.coin].quantity },{abortEarly:false}).then(() => {
                //                     saveCoin({
                //                         coin: coin.coin,
                //                         usdtVolume: coinsData[coin.coin].quantity,
                //                         price: coinsData[coin.coin].price,
                //                         cryptoVolume: coin.cryptoVolume
                //                     }).then(sleep).then(res => {
                //                         delete coinsData[coin.coin];
                //                         setCoinsData(coinsData);
                //                         reloadDocument();
                //                     }).finally(() => setProcessing(false));
                //                 }).catch(onError);
                //             }
                //         }
                //     };
                // };
                const row: any = {
                    id: coin.coin,
                    step: null,
                    status: "template",
                    approval_date: date || "-",
                    type: t("sell_string").toUpperCase(),
                    text: coin.coin + " ⇄ USD",
                    currency_type: t("crypto_string"),
                    currency: coin.coin,
                    quantity: quantity,
                    //quantityDecimals: 8,
                    price: price,
                    priceDecimals: 8,
                    totalDecimals: 8,
                    total: coin.cryptoVolume,
                };
                data.splice(i++, 0, row);
                coins[coin.coin] = row;
            });
        };
        const setStepsProcessed = (steps: number) => {
            const c = data.length - 4 + steps;
            for (let i = 0; i < c; ++i) {
                data[i].status = "passed";
            }
        };
        const setStep1 = () => {
            getDocumentsByType("CRYPTO_SELL", { withdrawalId: doc.id }).then(res => {
                const doc = res.data.items ? res.data.items[0] : undefined;
                // console.log(res);
                setDocumentCoins(true, doc?.meta?.coins);
                setData(data);
            });
        };
        const setStep2 = (params?: any) => {
            const state = findState(doc, "crypto_sell");
            setDocumentCoins(false, state?.data?.coins, state?.dt);
            setStepsProcessed(1);
            const idx = data.length - 3;
            Object.assign(data[idx], {
                status: "active",
                type: t("sell_string").toUpperCase(),
                approval_date: state.dt,
                total: state.data.usdtValue,
                currency: "USD",
                price: "-",
                quantity: "-"
            }, params);
        };
        const setStep3 = (params?: any) => {
            const state = findState(doc, "withdrawal.eur_converted");
            setStep2({ status: "passed", quantity: state.data.eurValue, price: state.data.rate, editable: null });
            const idx = data.length - 2;
            Object.assign(data[idx], {
                status: "active",
                approval_date: state.dt,
                type: t("sell_string").toUpperCase(),
                total: state.data.eurValue,
                currency: "EUR",
                price: "-",
                quantity: "-",
            }, params);
        };
        const setStep4 = (params?: any) => {
            const state = findState(doc, "withdrawal.nis_converted");
            setStep3({ status: "passed", quantity: state.data.nisValue, price: state.data.rate, editable: null });
            const idx = data.length - 1;
            Object.assign(data[idx], {
                status: "passed",
                type: t("withdrawal_fee_string"),
                approval_date: state.dt,
                total: state.data.feeValue,
                currency: "NIS",
                price: 1,
                quantity: state.data.feeValue,
            });
            data.push({
                status: "passed",
                text: "NIS",
                currency: "NIS",
                approval_date: state.dt,
                currency_type: "Fiat",
                type: t("withdrawal_string"),
                total: state.data.debitedNis,
                quantity: state.data.debitedNis,
                price: 1
            });
            const state2 = findState(doc, "withdrawal.portfolio_processed");
            if (state2) {
                data.push({
                    status: "passed",
                    text: "NIS",
                    currency: "NIS",
                    approval_date: state.dt,
                    currency_type: "Fiat",
                    type: "Success fee",
                    total: state2.data.taxes?.success_fee,
                    quantity: state2.data.taxes?.success_fee,
                    price: 1
                });
                data.push({
                    status: "passed",
                    text: "NIS",
                    currency: "NIS",
                    approval_date: state.dt,
                    currency_type: "Fiat",
                    type: "Tax/Shield",
                    total: state2.data.taxes?.tax_computed,
                    quantity: state2.data.taxes?.tax_computed,
                    price: 1
                });
                data.push({
                    status: "passed",
                    text: "NIS",
                    currency: "NIS",
                    approval_date: state.dt,
                    currency_type: "Fiat",
                    type: "Available shield",
                    total: state2.data.taxes?.avl_tax_shield,
                    quantity: state2.data.taxes?.avl_tax_shield,
                    price: 1
                });
                data.push({
                    status: "passed",
                    text: "NIS",
                    currency: "NIS",
                    approval_date: state.dt,
                    currency_type: "Fiat",
                    type: "Withdrawal to transfer",
                    total: state2.data.taxes?.withdrawal_after_tax,
                    quantity: state2.data.taxes?.withdrawal_after_tax,
                    price: 1
                });
            }
        };
        switch (doc.meta.state) {
            case "pending":
                setStep1();
                break;
            case "rejected":
                data[0].status = "rejected";
                setDocumentCoins(false);
                setData(data);
                break;
            case "crypto_sell":
                setStep2();
                setData(data);
                break;
            case "withdrawal.eur_converted":
                setStep3();
                setData(data);
                break;
            case "withdrawal.nis_converted":
            case "withdrawal.portfolio_processed":
                setStep4();
                setData(data);
                break;
            default:
                console.log("STATUS", doc.meta.state);
        }
    };

    const reloadDocuments = () => {
        getDocument(id).then(doc => {
            if (doc) {
                processDocument(doc);
            }
        });
    };

    useEffect(() => {
        if (!user || !userCore) {
            return history.push('/');
        }
        reloadDocuments();
    }, []);

    useEffect(() => {
        if (!user) {
            return history.push('/');
        }
    }, [user, userCore]);

    return (
        <DocumentDetailsPage
            title={t("withdrawal_details_string")}
            columns={config}
            documentData={withdrawalData}
            bankDetails={bankDetailsData}
            stepsData={data}
/*             BAMCId={BAMCId}
            BAMCStatus={BAMCStatus}
            BAMCStatusClass={BAMCStatusClass}
 */            processing={false}
            itemComponent={StepsItemView}
/*             onViewBAMC={() => {
                console.log("VIEW DOCUMENT", BAMCId, bankDetailsData?.meta?.bank_details);
                //@ts-ignore
                setViewBAMC(true);
                // setViewBAMC(true);
                //@ts-ignore
                document.getElementById("view-document-btn").click();
            }}
 */        >
            {/*             {BAMCId ? <ViewDocumentModal closeModal={() => { setViewBAMC(false); }} openViewModal={viewBAMC} documentId={BAMCId} documentMeta={BAMCMeta} /> : null}
 */}
            {/*             <ViewDocumentModal documentId={BAMCId} openViewModal={viewBAMC} closeModal={() => {
                setViewBAMC(false);
                //@ts-ignore
                document.getElementById("view-document-btn-close").click();
            }} />
 */}
        </DocumentDetailsPage>
    );
}

export default WithdrawalDetails;
